import { Alert, Button, Flex, Text } from "@mantine/core";

export default function ContactMismatchAlert({
  formContact,
  dbContact,
  onSelectFormContact,
  onSelectDbContact,
  onDismiss,
}) {
  return (
    <Alert title="연락처 확인 필요" color="orange" withCloseButton onClose={onDismiss} mt="xs">
      <Text size="sm" mb="xs">
        입력된 담당자와 거래처의 담당자가 다릅니다.
      </Text>
      <Flex direction="column">
        <Text size="xs">입력된 담당자:</Text>
        <Button variant="default" color="brand" size="sm" onClick={onSelectFormContact} fullWidth>
          {formContact}
        </Button>
        <Text size="xs" mt="xs">
          거래처 담당자:
        </Text>
        <Button variant="default" color="purple" size="sm" onClick={onSelectDbContact} fullWidth>
          {dbContact}
        </Button>
      </Flex>
    </Alert>
  );
}
